import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { ButtonVariant } from '../button/button.component';

export type ModalSize = 'small' | 'medium' | 'large' | 'xl';
export type ModalPosition = 'center' | 'right';
export type ModalVariant = 'default' | 'success' | 'info' | 'warning' | 'error';

const VARIANT_ICON_MAP: { [key in ModalVariant]: string } = {
  default: '',
  success: 'check_circle',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnChanges, OnDestroy {
  @Input() isOpen: boolean = false;
  @Input() title: string = '';
  @Input() size: ModalSize = 'medium';
  @Input() position: ModalPosition = 'center';
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() showCloseButton: boolean = true;
  @Input() closeOnBackdropClick: boolean = true;
  @Input() closeOnEscKey: boolean = true;
  @Input() variant: ModalVariant = 'default';
  @Input() statusTitle: string = '';
  @Input() statusMessage: string = '';
  @Input() okText: string = '';
  @Input() cancelText: string = '';
  @Input() okButtonVariant: ButtonVariant = 'primary';
  @Input() cancelButtonVariant: ButtonVariant = 'secondary';

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      document.body.style.overflow = this.isOpen ? 'hidden' : '';
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.close.emit();
    }
  }

  onCloseClick(): void {
    this.close.emit();
  }

  onConfirmClick(): void {
    this.confirm.emit();
  }

  onEscKey(event: KeyboardEvent): void {
    if (this.closeOnEscKey && event.key === 'Escape') {
      this.close.emit();
    }
  }

  getModalClass(): string {
    return `modal-${this.size} modal-position-${this.position}`;
  }

  get hasStatusBlock(): boolean {
    return this.variant !== 'default';
  }

  get variantIcon(): string {
    return VARIANT_ICON_MAP[this.variant];
  }

  get hasBuiltInFooter(): boolean {
    return !!this.okText || !!this.cancelText;
  }
}
